import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=58505894&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=58505894&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58505894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58505894')) {
      api.createRecord('58505894', component.options)
    } else {
      api.reload('58505894', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=58505894&scoped=true", function () {
      api.rerender('58505894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/ForgotPassword.vue"
export default component.exports